<template>
    <div class="captcha-container" v-if="visible">
      <div class="captcha-wrapper">
        <!-- 背景图 -->
        <div class="captcha-image" :style="{ width: width + 'px', height: height + 'px' }">
          <img :src="backgroundUrl" alt="background" />
          <!-- 滑块缺口层 -->
          <div class="slider-gap" :style="gapStyle"></div>
        </div>
        
        <!-- 滑块轨道 -->
        <div class="slider-track" :style="{ width: width + 'px' }">
          <div   class="slider-button"  :style="{ left: sliderX + 'px' }"  @mousedown="handleMouseDown"  @touchstart="handleTouchStart">
            <span>▶</span>
          </div>
          <div class="slider-progress" :style="{ width: sliderX + 'px' }"></div>
        </div>
        
        <!-- 提示信息 -->
        <div class="captcha-message" :class="messageType">{{ message }}</div>
        
        <!-- 隐藏字段 -->
        <input type="hidden" :value="captchaToken" />
      </div>
    </div>
  </template>
  
  <script>
  import { ref, onMounted } from 'vue';
  import {generateCaptcha,verifyCaptch} from "../http/loginApi";  
  import * as FingerprintJS from '@fingerprintjs/fingerprintjs';
  export default {

    emits: ['success', 'fail'],
    setup(props,{ emit }){

        
        // 配置
        const width =ref(300);
        const height =ref(150);
        //const tolerance = 3; // 容错像素
        
        // 状态
        const visible = ref(true);
        const backgroundUrl = ref('');
        const sliderUrl = ref('');
        const gapStyle = ref({});
        const sliderX = ref(0);
        const isDragging = ref(false);
        const startX = ref(0);
        const track = ref([]);
        const deviceId = ref('');
        const captchaId = ref('');
        const captchaToken = ref('');
        const message = ref('请拖动滑块完成验证');
        const messageType = ref('info');
        
        // 获取设备指纹
        onMounted(async () => {
            const fp = await FingerprintJS.load();
            const result = await fp.get();
            deviceId.value = result.visitorId;
            
            // 加载验证码
            loadCaptcha();
        });
        
        // 加载验证码
        const loadCaptcha = async () => {
            let res=await generateCaptcha(deviceId.value)
            console.log(res)
            if(res.code==20000){
                const data = res.data;
                captchaId.value = data.captchaId;
                backgroundUrl.value = `data:image/png;base64,${data.backgroundImage}`;
                sliderUrl.value = `data:image/png;base64,${data.sliderImage}`;
                
                // 缺口位置（仅用于前端展示，真实位置后端校验）
                gapStyle.value = {
                    left:'0px',
                    top: data.gapY + 'px',
                    backgroundImage: `url(${sliderUrl.value})`,
                    backgroundSize: `${width.value}px ${height.value}px`,
                    backgroundPosition: `-${data.gapX}px -${data.gapY}px`
                };
            }else {
                message.value = '滑块验证加载失败';
                messageType.value = 'error';
            }
        };
        
        // 鼠标/触摸事件
        const handleMouseDown = (e) => {
            startDrag(e.clientX);
        };
        
        const handleTouchStart = (e) => {
            startDrag(e.touches[0].clientX);
        };
        
        const startDrag = (x) => {
            isDragging.value = true;
            startX.value = x - sliderX.value;
            track.value = [];
            
            document.addEventListener('mousemove', handleMouseMove);
            document.addEventListener('mouseup', handleMouseUp);
            document.addEventListener('touchmove', handleTouchMove);
            document.addEventListener('touchend', handleMouseUp);
        };
        
        const handleMouseMove = (e) => {
            if (!isDragging.value) return;
            moveSlider(e.clientX);
        };
        
        const handleTouchMove = (e) => {
            if (!isDragging.value) return;
            moveSlider(e.touches[0].clientX);
        };
        
        const moveSlider = (x) => {
            const newX = Math.max(0, Math.min(x - startX.value, width.value - 40));
            sliderX.value = newX;
            
            // 记录轨迹
            track.value.push({
            x: newX,
            y: 0, // Y轴不变
            t: Date.now()
            });
            
            // 更新缺口位置
            gapStyle.value.left = newX + 'px';
        };
        
        const handleMouseUp = async () => {
            if (!isDragging.value) return;
            isDragging.value = false;
            
            document.removeEventListener('mousemove', handleMouseMove);
            document.removeEventListener('mouseup', handleMouseUp);
            
            // 验证
            await verifyCaptcha();
        };
        
        // 验证滑块
        const verifyCaptcha = async () => {
            const res = await verifyCaptch( {
                captchaId: captchaId.value,
                sliderPosition: sliderX.value,
                track: track.value,
                deviceId: deviceId.value,
                timestamp: Date.now()
            });
            console.log(res)
            if(res.code==20000){
           
                //captchaToken.value = res.data.token;
                message.value = '验证成功';
                messageType.value = 'success';
                visible.value = false; // 隐藏滑块
                emit('success', { st: res.data.st });
            } else {
                message.value = res.message || '验证失败，请重试';
                messageType.value = 'error';
                resetSlider();
            }
        };
        
        // 重置滑块
        const resetSlider = () => {
            setTimeout(() => {
            sliderX.value = 0;
            track.value = [];
            message.value = '请拖动滑块完成验证';
            messageType.value = 'info';
            loadCaptcha();
            }, 1000);
        };
        return {
            visible,
            width,
            height,
            backgroundUrl,
            gapStyle,
            sliderX,
            captchaToken,
            message,
            messageType,
            handleMouseDown,
            handleTouchStart
        }
    }
  }
  </script>
  
  <style scoped>
  .captcha-container {
    padding: 20px;
    background: #fff;
    border-radius: 4px;
  }
  
  .captcha-image {
    position: relative;
    margin-bottom: 10px;
  }
  
  .captcha-image img {
    width: 100%;
    height: 100%;
    display: block;
  }
  
  .slider-gap {
    position: absolute;
    width: 40px;
    height: 40px;
    border: 1px solid #ddd;
    background-color: rgba(0, 0, 0, 0.1);
  }
  
  .slider-track {
    position: relative;
    height: 40px;
    background: #f0f0f0;
    border-radius: 20px;
  }
  
  .slider-button {
    position: absolute;
    width: 40px;
    height: 40px;
    background: #fff;
    border: 1px solid #ccc;
    border-radius: 50%;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 2px 4px rgba(0,0,0,0.2);
    z-index: 10;
  }
  
  .slider-button:hover {
    background: #f5f5f5;
  }
  
  .slider-progress {
    position: absolute;
    height: 100%;
    background: #52c41a;
    border-radius: 20px;
    opacity: 0.5;
  }
  
  .captcha-message {
    margin-top: 10px;
    text-align: center;
    font-size: 14px;
  }
  
  .message-info { color: #1890ff; }
  .message-success { color: #52c41a; }
  .message-error { color: #ff4d4f; }
  </style>